export enum TrackType {
    SKILL = "SKILL",
    CAREER = "CAREER",
    NONE = ""
}
